import React from 'react'
import { Alert, Button, Stack, Text } from '@mantine/core'

export const EventFormLoadError: React.FC<{
  onRetry: () => void
}> = ({ onRetry }) => (
  <Alert color="red" title="Unable to load event form">
    <Stack align="flex-start" spacing="sm">
      <Text size="sm">
        The reporter or feedback information couldn&apos;t be loaded. Check your
        connection and try again.
      </Text>
      <Button color="red" size="xs" variant="light" onClick={onRetry}>
        Try again
      </Button>
    </Stack>
  </Alert>
)
